import type { Form } from '@coursera/event-pulse-types';

import { PATHWAYS_ONBOARDING_MODULAR_EVENT_NAME } from 'bundles/onboarding-common/constants';
import { useOnboardingProgress } from 'bundles/onboarding-common/contexts/OnboardingProgressContext';

const useFormEventingData = (): { formEventData: Form } => {
  const { currentStep, totalSteps } = useOnboardingProgress();

  return {
    formEventData: {
      name: PATHWAYS_ONBOARDING_MODULAR_EVENT_NAME,
      currentStep,
      totalSteps,
    },
  };
};

export default useFormEventingData;
